/* oxlint-disable react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md */
import { useMutation, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import {
    Body1,
    Button,
    Heading1,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { getFragment } from '../../../graphql/client/helpers/get-fragment';
import {
    GetPrescriberOrderDocument,
    RequestPrescriberOrderModificationDocument,
} from '../../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';
import { Loader } from '../../common/Loader';

export const OtherOptionsPage = () => {
    const { prescriberOrderId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!prescriberOrderId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const { data, loading } = useQuery(GetPrescriberOrderDocument, {
        variables: { prescriberOrderId },
    });

    const [RequestPrescriptionModification] = useMutation(
        RequestPrescriberOrderModificationDocument
    );

    if (loading) {
        return <Loader />;
    }

    const prescriberOrder = getFragment(data?.prescriberOrderV2);

    if (!data || !prescriberOrder) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const prescriber =
        prescriberOrder?.__typename === 'DigitallyReceivedPrescriberOrder'
            ? getFragment(prescriberOrder?.prescriber)
            : null;
    const phone = prescriber?.phoneNumber ?? null;

    const handleCallPrescriber = async () => {
        await RequestPrescriptionModification({
            variables: {
                prescriberOrderId,
                preventAutoRoute: true,
            },
        });

        if (phone) {
            location.href = `tel:${phone}`;
        }
    };

    const handleKeepPrescription = () => {
        navigate(
            getAbsoluteRoute('order.prescriberOrderId.details', {
                prescriberOrderId,
            })
        );
    };

    return (
        <Stack
            style={{
                height: '80vh',
                justifyContent: 'space-between',
            }}
        >
            <Stack gap="sm">
                <Heading1>{t('otherOptions.title')}</Heading1>
                <Body1>{t('otherOptions.body.part1')}</Body1>
                <Body1>{t('otherOptions.body.part2')}</Body1>
            </Stack>
            <Stack gap="xs">
                {phone ? (
                    <Button onClick={handleCallPrescriber}>
                        {t('otherOptions.button.callPrescriber')}
                    </Button>
                ) : null}
                <Button variant="outline" onClick={handleKeepPrescription}>
                    {t('otherOptions.button.keepPrescription')}
                </Button>
            </Stack>
        </Stack>
    );
};
